export default __webpack_public_path__ + "static/media/arrow_down.3b586c35.svg";